/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
// other
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Collapse, Container, Row } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import {
  TKubunBunruiInfoRes,
  TKubunBunruiPutReq,
  TMasterKubunListGetRes,
  TMasterKubunListItem,
  TMasterKubunPutReq,
} from "../../../service/master/kubun/TKubun"
import CONSTANT from "../../../constant"
import KubunService from "../../../service/master/kubun/kubunService"
import { TApiResponse } from "../../../service/TApiResponse"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import TextInput from "../../../components/InputWrapper/TextInput"
import { showInfoToast } from "../../../components/CustomToast"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import util from "../../../ts/util"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import dateUtil from "../../../ts/util/dateUtil"
import Ajv, { ErrorObject } from "ajv"
import ajvErrors from "ajv-errors"
import {
  kubunBunruiRegisterPostScheme,
  kubunBunruiRegisterPutScheme,
} from "../../../service/master/kubun/kubunBunruiScheme"
import { kubunRegisterPostScheme } from "../../../service/master/kubun/kubunScheme"
import CheckInput from "../../../components/InputWrapper/CheckInput"

//#region [type]
export type T区分リスト = TMasterKubunListGetRes & {
  行ID: symbol

  /**
   * yyyy/mm/dd hh:mm:ss表記
   */
  str更新日時?: string
}

export type T区分分類リスト = TKubunBunruiInfoRes & {
  行ID: symbol
}

//#endregion

/**
 * 区分マスタ登録
 * @returns
 */
const MasterKubunRegister = () => {
  const history = useHistory()
  const { id: paramId } = useParams<{ id: string }>()
  const id = parseInt(paramId)
  const disPatch: AppDispatch = useDispatch()

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  let gridId = "MasterKubunRegister"

  //#region [state]

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  // 表示項目のstate
  const [分類コード, set分類コード] = useState<string>()
  const [分類名, set分類名] = useState<string>()
  const [ソート番号, setソート番号] = useState<string>()
  const [備考, set備考] = useState<string>()
  const [更新日時, set更新日時] = useState<string>()
  const [更新ユーザID, set更新ユーザID] = useState<string>()
  const [区分追加可能フラグ, set区分追加可能フラグ] = useState<number>()
  const [区分削除可能フラグ, set区分削除可能フラグ] = useState<number>()
  const [区分名称1変更可能フラグ, set区分名称1変更可能フラグ] =
    useState<number>()
  const [区分名称2変更可能フラグ, set区分名称2変更可能フラグ] =
    useState<number>()
  const [区分名称3変更可能フラグ, set区分名称3変更可能フラグ] =
    useState<number>()
  const [区分数値1変更可能フラグ, set区分数値1変更可能フラグ] =
    useState<number>()
  const [区分数値2変更可能フラグ, set区分数値2変更可能フラグ] =
    useState<number>()
  const [区分数値3変更可能フラグ, set区分数値3変更可能フラグ] =
    useState<number>()
  const [区分小数値1変更可能フラグ, set区分小数値1変更可能フラグ] =
    useState<number>()
  const [区分小数値2変更可能フラグ, set区分小数値2変更可能フラグ] =
    useState<number>()
  const [区分小数値3変更可能フラグ, set区分小数値3変更可能フラグ] =
    useState<number>()

  // modal
  const [isKubunConfirmModalShow, setIsKubunConfirmModalShow] = useState(false)
  const [isKubunBunruiConfirmModalShow, setIsKubunBunruiConfirmModalShow] =
    useState(false)

  //　エラー表示用フラグ
  const [isInvalid分類名, setIsInvalid分類名] = useState<boolean>(false)
  const [isInvalidソート番号, setIsInvalidソート番号] = useState<boolean>(false)
  const [isInvalid備考, setIsInvalid備考] = useState<boolean>(false)
  const [errorCellPositionList] = useState<
    Array<{ 行ID: symbol; colBinding: string }>
  >([])

  //#endregion

  //#region [method]

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (id: number) => {
    disPatch(clearAlert()) //アラート非表示

    try {
      const service = new KubunService()
      const res = (await service.get(id)) as TApiResponse<TMasterKubunListItem>

      if (res.data) {
        set分類コード(res.data.分類コード)
        set分類名(res.data.分類名)
        setソート番号(res.data.ソート番号 ? res.data.ソート番号.toString() : "")
        set区分追加可能フラグ(res.data.区分追加可能フラグ)
        set区分削除可能フラグ(res.data.区分削除可能フラグ)
        set区分名称1変更可能フラグ(res.data.区分名称1変更可能フラグ ?? 0)
        set区分名称2変更可能フラグ(res.data.区分名称2変更可能フラグ ?? 0)
        set区分名称3変更可能フラグ(res.data.区分名称3変更可能フラグ ?? 0)
        set区分数値1変更可能フラグ(res.data.区分数値1変更可能フラグ ?? 0)
        set区分数値3変更可能フラグ(res.data.区分数値3変更可能フラグ ?? 0)
        set区分数値2変更可能フラグ(res.data.区分数値3変更可能フラグ ?? 0)
        set区分小数値1変更可能フラグ(res.data.区分小数値1変更可能フラグ ?? 0)
        set区分小数値2変更可能フラグ(res.data.区分小数値2変更可能フラグ ?? 0)
        set区分小数値3変更可能フラグ(res.data.区分小数値3変更可能フラグ ?? 0)
        set備考(res.data.備考)
        let res区分リスト: TMasterKubunListGetRes[] = res.data.区分リスト
        set更新日時(res.data.更新日時)
        set更新ユーザID(
          res.data.更新ユーザID ? res.data.更新ユーザID.toString() : ""
        )
        setGridData({ data: createCollectionView(res区分リスト) })
      }
    } catch (error) {
      disPatch(setWarningAlerts(["エラー表示"]))
    } finally {
    }
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<TMasterKubunListGetRes>) => {
    const bindItems: TMasterKubunListGetRes[] = data.map((item) => {
      return {
        ...item,
      }
    })
    return new wjCore.CollectionView(bindItems, {
      //新規で作るとき
      newItemCreator() {
        return {
          区分ID: null,
          更新ユーザID: 更新ユーザID,
          変更可能フラグ: 1,
          更新日時: 更新日時,
        } as Partial<TMasterKubunListItem>
      },
      calculatedFields: {
        str更新日時: (item: T区分リスト) =>
          !wjCore.isNullOrWhiteSpace(item.更新日時 ?? "")
            ? dateUtil.format(item.更新日時, "YYYY/MM/DD HH:mm:ss")
            : "",
      },
    })
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.refresh()
  }
  /**
   * 区分更新
   */
  const kubunSubmit = async () => {
    try {
      const service = new KubunService()
      let res: TApiResponse<boolean>
      res = await service.kubunPut(id, await getData())
      if (res) {
        isPrompt.current = false
        disPatch(setAlerts(res))
        showInfoToast(`区分マスタの更新が完了しました`)
        history.goBack()
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsKubunConfirmModalShow(false)
    }
  }

  /**
   * 区分分類更新
   */
  const kubunBunruiSubmit = async () => {
    try {
      if (分類名 === "" || ソート番号 == null) return

      const service = new KubunService()
      let res: TApiResponse<boolean>
      res = await service.kubunBunruiPut(id, await getKubunBunruiPutReq())
      if (res) {
        isPrompt.current = false
        disPatch(setAlerts(res))
        showInfoToast(`区分マスタの更新が完了しました`)
        history.goBack()
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsKubunBunruiConfirmModalShow(false)
    }
  }

  /**
   * 更新用データ取得
   */
  const getData = async () => {
    const 区分リストitems: TMasterKubunPutReq[] = []
    const gData: T区分リスト[] = gridData.data.items
    gData.forEach((r) => {
      let 区分item: TMasterKubunPutReq = {
        区分ID: r.区分ID,
        区分コード: r.区分コード,
        名称1: r.名称1,
        名称2: r.名称2,
        名称3: r.名称3,
        数値1: r.数値1,
        数値2: r.数値2,
        数値3: r.数値3,
        小数値1: r.小数値1,
        小数値2: r.小数値2,
        小数値3: r.小数値3,
        ソート番号: r.ソート番号,
        変更可能フラグ: r.変更可能フラグ ? 1 : 0,
        備考: r.備考,
        更新日時: r.区分ID != null ? r.更新日時 : undefined,
      }
      区分リストitems.push(区分item)
    })
    let putData: TMasterKubunListItem = {
      分類コード: 分類コード ?? "",
      区分リスト: 区分リストitems!,
    }
    return putData
  }

  /**
   * 区分分類更新用データ取得
   */
  const getKubunBunruiPutReq = (): TKubunBunruiPutReq => {
    return {
      分類コード: 分類コード ?? "",
      分類名: 分類名 ?? "",
      ソート番号: parseInt(ソート番号 ?? "") ?? 0,
      区分名称1変更可能フラグ: 区分名称1変更可能フラグ ? 1 : 0,
      区分名称2変更可能フラグ: 区分名称2変更可能フラグ ? 1 : 0,
      区分名称3変更可能フラグ: 区分名称3変更可能フラグ ? 1 : 0,
      区分数値1変更可能フラグ: 区分数値1変更可能フラグ ? 1 : 0,
      区分数値2変更可能フラグ: 区分数値2変更可能フラグ ? 1 : 0,
      区分数値3変更可能フラグ: 区分数値3変更可能フラグ ? 1 : 0,
      区分小数値1変更可能フラグ: 区分小数値1変更可能フラグ ? 1 : 0,
      区分小数値2変更可能フラグ: 区分小数値2変更可能フラグ ? 1 : 0,
      区分小数値3変更可能フラグ: 区分小数値3変更可能フラグ ? 1 : 0,
      区分追加可能フラグ: 区分追加可能フラグ ? 1 : 0,
      区分削除可能フラグ: 区分削除可能フラグ ? 1 : 0,
      備考: 備考 ?? "",
      更新日時: 更新日時 ?? "",
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  // エラーメッセージセット
  const setValidateError = (
    errors: ErrorObject<string, Record<string, any>, unknown>[]
  ) => {
    const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
    const requiredProperties = errors
      .filter(
        (e) =>
          e.instancePath === "" &&
          e.params.errors != null &&
          e.params.errors.length > 0 &&
          e.params.errors.find(
            (ec: { keyword: string }) => ec.keyword === "required"
          )
      )
      .map((e) => {
        const error = e.params.errors[0]
        return error.params.missingProperty
      })
    const errorProperties = [...instancePaths, ...requiredProperties]
    setIsInvalid分類名(errorProperties.includes("分類名"))
    setIsInvalidソート番号(errorProperties.includes("ソート番号"))
    setIsInvalid備考(errorProperties.includes("備考"))
  }

  //区分分類バリデーションチェック
  const beforeKubunBunruiSubmit = async () => {
    const ajv = new Ajv({ allErrors: true })
    const duplicate = await duplicatesKubunBunruiConfirm()
    if (!duplicate) {
      return
    }
    ajvErrors(ajv)
    let schema
    if (!id) {
      schema = kubunBunruiRegisterPostScheme
    } else {
      schema = kubunBunruiRegisterPutScheme
    }
    const validate = ajv.compile(schema)
    const data = {
      分類コード,
      分類名,
      ソート番号: parseInt(ソート番号 ?? ""),
      備考,
      更新日時,
    }
    const validateResult = validate(data)
    if (!validateResult) {
      const errors = validate.errors
      if (errors != null && errors.length > 0) {
        // 色変更
        setValidateError(errors)
        disPatch(
          setWarningAlerts([
            ...errors
              .filter((e) => e.message != null)
              .map((e) => e.message ?? ""),
          ])
        )
        return
      }
    } else {
      setIsKubunBunruiConfirmModalShow(true)
    }
  }

  // 区分分類重複チェック
  const duplicatesKubunBunruiConfirm = async () => {
    const res = await new KubunService().getKubunBunruiList()
    const 区分分類アイテム: Array<TKubunBunruiPutReq> = []
    const arrayDataList: TKubunBunruiInfoRes[] = res.data
    const duplicateItems: TKubunBunruiPutReq[] = []
    区分分類アイテム.push({
      分類コード: 分類コード ?? "",
      分類名: 分類名 ?? "",
      ソート番号: parseInt(ソート番号 ?? "") ?? 0,
      区分名称1変更可能フラグ: 区分名称1変更可能フラグ ? 1 : 0,
      区分名称2変更可能フラグ: 区分名称2変更可能フラグ ? 1 : 0,
      区分名称3変更可能フラグ: 区分名称3変更可能フラグ ? 1 : 0,
      区分数値1変更可能フラグ: 区分数値1変更可能フラグ ? 1 : 0,
      区分数値2変更可能フラグ: 区分数値2変更可能フラグ ? 1 : 0,
      区分数値3変更可能フラグ: 区分数値3変更可能フラグ ? 1 : 0,
      区分小数値1変更可能フラグ: 区分小数値1変更可能フラグ ? 1 : 0,
      区分小数値2変更可能フラグ: 区分小数値2変更可能フラグ ? 1 : 0,
      区分小数値3変更可能フラグ: 区分小数値3変更可能フラグ ? 1 : 0,
      区分追加可能フラグ: 区分追加可能フラグ ? 1 : 0,
      区分削除可能フラグ: 区分削除可能フラグ ? 1 : 0,
      備考: 備考 ?? "",
      更新日時: 更新日時 ?? "",
    })
    for (const arrayData of arrayDataList) {
      const ソート番号 = arrayData.ソート番号 ?? 0
      const 分類コード = arrayData.分類コード
      for (const putItem of 区分分類アイテム) {
        if (
          putItem.ソート番号 === ソート番号 &&
          putItem.分類コード !== 分類コード
        ) {
          duplicateItems.push(putItem)
        }
      }
    }
    if (duplicateItems.length > 0) {
      disPatch(
        setWarningAlerts([`分類ソート番号${ソート番号}が重複しています。`])
      )
      return false
    } else {
      return true
    }
  }
  //区分バリデーションチェック
  const beforeKubunSubmit = () => {
    errorCellPositionList.splice(0, errorCellPositionList.length)
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    let schema = kubunRegisterPostScheme
    const duplicate = duplicatesKubunConfirm()
    if (!duplicate) {
      return
    }
    let [行IDList, dataList] = createTMasterKubunPutReq()
    dataList.forEach((data, i) => {
      if (data.削除フラグ === 1) return
      const validate = ajv.compile(schema)
      const validateResult = validate(data)

      if (!validateResult) {
        validate.errors?.forEach((error) => {
          const colBinding = error.instancePath.slice(1)
          if (
            !errorCellPositionList.find(
              (e) => e.行ID === 行IDList[i] && e.colBinding === colBinding
            )
          ) {
            errorCellPositionList.push({ 行ID: 行IDList[i], colBinding })
          }
        })
      }
    })
    if (errorCellPositionList.length <= 0) {
      setIsKubunConfirmModalShow(true)
    } else {
      disPatch(setWarningAlerts(["区分の入力に不備があります。"]))
    }
  }

  //バリデーションチェック用区分取得
  const createTMasterKubunPutReq = (): [symbol[], TMasterKubunPutReq[]] => {
    const 行IDList: symbol[] = []
    const 区分リスト: Array<TMasterKubunPutReq> = []
    const arrayDataList: T区分リスト[] = gridData.data.items
    for (const arrayData of arrayDataList) {
      行IDList.push(arrayData.行ID)
      区分リスト.push({
        区分コード: arrayData.区分コード,
        名称1: arrayData.名称1,
        名称2: arrayData.名称2,
        名称3: arrayData.名称3,
        数値1: arrayData.数値1,
        数値2: arrayData.数値2,
        数値3: arrayData.数値3,
        小数値1: Number(arrayData.小数値1 ?? ""),
        小数値2: Number(arrayData.小数値2 ?? ""),
        小数値3: Number(arrayData.小数値3 ?? ""),
        ソート番号: arrayData.ソート番号,
        備考: arrayData.備考,
        変更可能フラグ: arrayData.変更可能フラグ ? 1 : 0,
        削除フラグ: arrayData.削除フラグ,
        更新ユーザID: arrayData.更新ユーザID,
        更新日時: arrayData.str更新日時,
      })
    }
    return [行IDList, 区分リスト]
  }

  // 区分重複チェック
  const duplicatesKubunConfirm = () => {
    const 行IDList: symbol[] = []
    const 区分リスト: Array<TMasterKubunPutReq> = []
    const arrayDataList: T区分リスト[] = gridData.data.items
    const ソート番号Map: Map<number, symbol[]> = new Map()
    const 区分コードMap: Map<string, symbol[]> = new Map()
    try {
      for (const arrayData of arrayDataList) {
        // 区分コード
        const 区分コード = arrayData.区分コード ?? ""
        if (区分コード === "") {
          disPatch(setWarningAlerts(["区分コードは必須入力です。"]))
          throw new Error()
        }
        if (arrayData.区分コード && !区分コードMap.has(区分コード)) {
          区分コードMap.set(区分コード, [])
          区分コードMap.get(区分コード)?.push(arrayData.行ID)
        }
        // ソート番号
        const ソート番号 = arrayData.ソート番号 ?? 0
        if (arrayData.ソート番号) {
          if (!ソート番号Map.has(ソート番号)) {
            ソート番号Map.set(ソート番号, [])
          }
          ソート番号Map.get(ソート番号)?.push(arrayData.行ID)
        } else {
          disPatch(setWarningAlerts(["ソート番号は1以上で、必須入力です。"]))
          throw new Error()
        }

        行IDList.push(arrayData.行ID)
        区分リスト.push({
          区分コード: arrayData.区分コード,
          名称1: arrayData.名称1,
          名称2: arrayData.名称2,
          名称3: arrayData.名称3,
          数値1: arrayData.数値1,
          数値2: arrayData.数値2,
          数値3: arrayData.数値3,
          小数値1: Number(arrayData.小数値1) ?? null,
          小数値2: Number(arrayData.小数値2) ?? null,
          小数値3: Number(arrayData.小数値3) ?? null,
          ソート番号: arrayData.ソート番号,
          備考: arrayData.備考,
          変更可能フラグ: arrayData.変更可能フラグ ? 1 : 0,
          削除フラグ: arrayData.削除フラグ,
          更新ユーザID: arrayData.更新ユーザID,
          更新日時: arrayData.str更新日時,
        })
        for (const [区分コード, 行IDList] of 区分コードMap.entries()) {
          if (行IDList.length > 1) {
            disPatch(
              setWarningAlerts([`区分コード${区分コード}が重複しています。`])
            )
            throw new Error()
          }
        }
        for (const [ソート番号, 行IDList] of ソート番号Map.entries()) {
          if (行IDList.length > 1) {
            disPatch(
              setWarningAlerts([`ソート番号${ソート番号}が重複しています。`])
            )
            throw new Error()
          }
        }
      }
    } catch (error) {
      return false
    }
    return true
  }

  //gridの必須チェック
  const formatItemHandler = (
    f: wjGrid.FlexGrid,
    e: wjGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        let isErrorCell = false
        const rowData: T区分リスト = e.getRow().dataItem
        const cellBinding = e.getColumn().binding

        // 削除フラグ
        const row = e.getRow()
        row.isReadOnly = rowData.削除フラグ === 1
        wjCore.toggleClass(e.cell, "read-only-cell", rowData.削除フラグ === 1)

        // エラーセルの色変え
        if (
          errorCellPositionList.find(
            (e) => e.colBinding === cellBinding && e.行ID === rowData.行ID
          )
        ) {
          isErrorCell = true
        }
        wjCore.toggleClass(e.cell, "data-warning", isErrorCell)
      }
    }
  }

  //#endregion
  //#region [baseState]
  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)
  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([]),
  })
  const [pageNumber] = useState<number>(0)
  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())
    if (id) {
      search(id).finally(() => {
        disPatch(画面ロック解除())
      })
    } else {
      disPatch(画面ロック解除())
    }
  }, [])
  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">区分マスタ{id ? "更新" : "登録"}</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="w-58rem">
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                区分分類
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body>
                  <Container fluid className="register-form">
                    {/* 分類コード */}
                    <MasterRegisterFormRow
                      label="分類コード"
                      isRequired={false}>
                      <div className="w-6rem">
                        <TextInput
                          id="分類コード"
                          name="分類コード"
                          value={分類コード}
                          setValue={(v) => {
                            set分類コード(v)
                          }}
                          isReadOnly
                        />
                      </div>
                    </MasterRegisterFormRow>
                    {/* 分類名 */}
                    <MasterRegisterFormRow label="分類名" isRequired={true}>
                      <div className="w-15rem">
                        <TextInput
                          id="分類名"
                          name="分類名"
                          isRequired
                          value={分類名}
                          setValue={(v) => {
                            set分類名(v)
                          }}
                          className={isInvalid分類名 ? "is-error" : ""}
                        />
                      </div>
                    </MasterRegisterFormRow>
                    {/* 分類ソート番号 */}
                    <MasterRegisterFormRow
                      label="分類ソート番号"
                      isRequired={true}>
                      <TextInput
                        style={{ width: "8rem" }}
                        id="ソート番号"
                        isRequired
                        name="ソート番号"
                        value={ソート番号}
                        setValue={(v) => {
                          setソート番号(v)
                        }}
                        className={isInvalidソート番号 ? "is-error" : ""}
                      />
                    </MasterRegisterFormRow>
                    <div className="register-form-row">
                      {/* 区分追加可能フラグ */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="区分追加可能フラグ">
                            区分追加可能フラグ
                          </label>
                        </div>
                        <CheckInput
                          id="区分追加可能フラグ"
                          isDisabled
                          label={""}
                          setValue={set区分追加可能フラグ}
                          type={"switch"}
                          value={区分追加可能フラグ ?? 0}
                        />
                      </div>
                      <div className="register-form-row">
                        {/* 区分削除可能フラグ */}
                        <div className="register-form-item">
                          <div className="register-form-label w-10rem">
                            <label htmlFor="区分削除可能フラグ">
                              区分削除可能フラグ
                            </label>
                          </div>
                          <CheckInput
                            id="区分削除可能フラグ"
                            isDisabled
                            label={""}
                            setValue={set区分削除可能フラグ}
                            type={"switch"}
                            value={区分削除可能フラグ ?? 0}
                          />
                        </div>
                      </div>
                    </div>
                    {/* 名称 */}
                    <div className="register-form-row">
                      {/* 名称1変更可能フラグ */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="名称1変更可能フラグ">
                            名称1変更可能
                          </label>
                        </div>
                        <CheckInput
                          id="区分名称1変更可能フラグ"
                          isDisabled
                          label={""}
                          setValue={set区分名称1変更可能フラグ}
                          type={"switch"}
                          value={区分名称1変更可能フラグ ?? 0}
                        />
                      </div>
                      <div className="register-form-row">
                        {/* 名称2変更可能フラグ */}
                        <div className="register-form-item">
                          <div className="register-form-label w-10rem">
                            <label htmlFor="名称2変更可能フラグ">
                              名称2変更可能
                            </label>
                          </div>
                          <CheckInput
                            id="区分名称2変更可能フラグ"
                            isDisabled
                            label={""}
                            setValue={set区分名称2変更可能フラグ}
                            type={"switch"}
                            value={区分名称2変更可能フラグ ?? 0}
                          />
                        </div>
                        <div className="register-form-row">
                          {/* 名称3変更可能フラグ */}
                          <div className="register-form-item">
                            <div className="register-form-label w-10rem">
                              <label htmlFor="名称3変更可能フラグ">
                                名称3変更可能
                              </label>
                            </div>
                            <CheckInput
                              id="名称3変更可能フラグ"
                              isDisabled
                              label={""}
                              setValue={set区分名称3変更可能フラグ}
                              type={"switch"}
                              value={区分名称3変更可能フラグ ?? 0}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* 数値 */}
                    <div className="register-form-row">
                      {/* 数値1変更可能フラグ */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="数値1変更可能フラグ">
                            数値1変更可能
                          </label>
                        </div>
                        <CheckInput
                          id="数値1変更可能フラグ"
                          isDisabled
                          label={""}
                          setValue={set区分数値1変更可能フラグ}
                          type={"switch"}
                          value={区分数値1変更可能フラグ ?? 0}
                        />
                      </div>
                      <div className="register-form-row">
                        {/* 数値2変更可能フラグ */}
                        <div className="register-form-item">
                          <div className="register-form-label w-10rem">
                            <label htmlFor="数値2変更可能フラグ">
                              数値2変更可能
                            </label>
                          </div>
                          <CheckInput
                            id="数値2変更可能フラグ"
                            isDisabled
                            label={""}
                            setValue={set区分数値2変更可能フラグ}
                            type={"switch"}
                            value={区分数値2変更可能フラグ ?? 0}
                          />
                        </div>
                        <div className="register-form-row">
                          {/* 数値3変更可能フラグ */}
                          <div className="register-form-item">
                            <div className="register-form-label w-10rem">
                              <label htmlFor="数値3変更可能フラグ">
                                数値3変更可能
                              </label>
                            </div>
                            <CheckInput
                              id="数値3変更可能フラグ"
                              isDisabled
                              label={""}
                              setValue={set区分数値3変更可能フラグ}
                              type={"switch"}
                              value={区分数値3変更可能フラグ ?? 0}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* 小数値 */}
                    <div className="register-form-row">
                      {/* 小数値1変更可能フラグ */}
                      <div className="register-form-item">
                        <div className="register-form-label w-10rem">
                          <label htmlFor="小数値1変更可能フラグ">
                            小数値1変更可能
                          </label>
                        </div>
                        <CheckInput
                          id="小数値1変更可能フラグ"
                          isDisabled
                          label={""}
                          setValue={set区分小数値1変更可能フラグ}
                          type={"switch"}
                          value={区分小数値1変更可能フラグ ?? 0}
                        />
                      </div>
                      <div className="register-form-row">
                        {/* 小数値2変更可能フラグ */}
                        <div className="register-form-item">
                          <div className="register-form-label w-10rem">
                            <label htmlFor="小数値2変更可能フラグ">
                              小数値2変更可能
                            </label>
                          </div>
                          <CheckInput
                            id="小数値2変更可能フラグ"
                            isDisabled
                            label={""}
                            setValue={set区分小数値2変更可能フラグ}
                            type={"switch"}
                            value={区分小数値2変更可能フラグ ?? 0}
                          />
                        </div>
                        <div className="register-form-row">
                          {/* 名称3変更可能フラグ */}
                          <div className="register-form-item">
                            <div className="register-form-label w-10rem">
                              <label htmlFor="小数値3変更可能フラグ">
                                小数値3変更可能
                              </label>
                            </div>
                            <CheckInput
                              id="小数値3変更可能フラグ"
                              isDisabled
                              label={""}
                              setValue={set区分小数値3変更可能フラグ}
                              type={"switch"}
                              value={区分小数値3変更可能フラグ ?? 0}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* 備考 */}
                    <MasterRegisterFormRow label="分類備考" isRequired={false}>
                      <div className="w-30rem">
                        <TextInput
                          id="備考"
                          name="備考"
                          value={備考}
                          setValue={(v) => {
                            set備考(v)
                          }}
                          className={isInvalid備考 ? "is-error" : ""}
                        />
                      </div>
                    </MasterRegisterFormRow>
                    <>
                      <Row>
                        <Col>
                          更新日時:{" "}
                          {util.date.format(更新日時, "YYYY/MM/DD HH:mm:ss")}
                        </Col>
                      </Row>
                      <Row>
                        <Col>更新ユーザID : {更新ユーザID}</Col>
                      </Row>
                    </>
                  </Container>
                  <>
                    <Button
                      className="mx-1"
                      variant="waiting"
                      onClick={() => {
                        beforeKubunBunruiSubmit()
                      }}>
                      {id ? "更新" : "登録"}
                    </Button>
                    <Button
                      type="button"
                      variant="secondary"
                      className="ms-4"
                      onClick={() => history.goBack()}>
                      一覧に戻る
                    </Button>
                  </>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <Card.Header>区分</Card.Header>
              <Card.Body>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  formatItem={formatItemHandler}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                  }
                  gridData={gridData}
                  gridId={gridId}
                  gridInitialized={gridInitialized}
                  gridInitializedHandler={gridInitializedHandler}
                  isRestoreSearching={isRestoreSearching}
                  pageNumber={pageNumber}
                  pageSize={pageSize}
                  setFlexGrid={setFlexGrid}
                  setGridData={setGridData}
                  setGridInitialized={setGridInitialized}
                  setIsRestoreSearching={setIsRestoreSearching}
                  setPageSize={setPageSize}>
                  <wjrGrid.FlexGridColumn
                    binding="区分コード"
                    width={100}
                    isReadOnly={区分追加可能フラグ ? false : true}
                    cssClass={区分追加可能フラグ ? "" : "read-only-cell"}
                    isRequired={true}
                    header="区分コード"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="名称1"
                    width={90}
                    isRequired={true}
                    isReadOnly={区分名称1変更可能フラグ ? false : true}
                    cssClass={区分名称1変更可能フラグ ? "" : "read-only-cell"}
                    maxLength={100}
                    header="名称1"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="名称2"
                    isReadOnly={区分名称2変更可能フラグ ? false : true}
                    cssClass={区分名称2変更可能フラグ ? "" : "read-only-cell"}
                    maxLength={100}
                    width={90}
                    header="名称2"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="名称3"
                    isReadOnly={区分名称3変更可能フラグ ? false : true}
                    cssClass={区分名称3変更可能フラグ ? "" : "read-only-cell"}
                    width={90}
                    maxLength={100}
                    header="名称3"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="数値1"
                    isReadOnly={区分数値1変更可能フラグ ? false : true}
                    cssClass={区分数値1変更可能フラグ ? "" : "read-only-cell"}
                    width={80}
                    maxLength={10}
                    header="数値1"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="数値2"
                    isReadOnly={区分数値2変更可能フラグ ? false : true}
                    cssClass={区分数値2変更可能フラグ ? "" : "read-only-cell"}
                    width={80}
                    maxLength={10}
                    header="数値2"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="数値3"
                    isReadOnly={区分数値3変更可能フラグ ? false : true}
                    cssClass={区分数値3変更可能フラグ ? "" : "read-only-cell"}
                    width={80}
                    maxLength={10}
                    header="数値3"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="小数値1"
                    isReadOnly={区分小数値1変更可能フラグ ? false : true}
                    cssClass={区分小数値1変更可能フラグ ? "" : "read-only-cell"}
                    width={90}
                    header="小数値1"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="小数値2"
                    isReadOnly={区分小数値2変更可能フラグ ? false : true}
                    cssClass={区分小数値2変更可能フラグ ? "" : "read-only-cell"}
                    width={90}
                    maxLength={11}
                    header="小数値2"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="小数値3"
                    isReadOnly={区分小数値3変更可能フラグ ? false : true}
                    cssClass={区分小数値3変更可能フラグ ? "" : "read-only-cell"}
                    width={90}
                    maxLength={11}
                    header="小数値3"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="ソート番号"
                    width={100}
                    isReadOnly={区分追加可能フラグ ? false : true}
                    cssClass={区分追加可能フラグ ? "" : "read-only-cell"}
                    maxLength={10}
                    header="ソート番号"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="変更可能フラグ"
                    width={125}
                    isReadOnly={true}
                    dataType={wjCore.DataType.Boolean}
                    header="変更可能フラグ"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="備考"
                    width={150}
                    isReadOnly={区分追加可能フラグ ? false : true}
                    cssClass={区分追加可能フラグ ? "" : "read-only-cell"}
                    maxLength={1000}
                    header="備考"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="str更新日時"
                    width={175}
                    isReadOnly={true}
                    cssClass={"read-only-cell"}
                    header="更新日時"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="更新ユーザID"
                    width={125}
                    isReadOnly={true}
                    cssClass={"read-only-cell"}
                    header="更新ユーザID"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
                <>
                  <Button
                    className="mx-1"
                    variant="waiting"
                    onClick={() => {
                      beforeKubunSubmit()
                    }}>
                    {id ? "更新" : "登録"}
                  </Button>
                  <Button
                    type="button"
                    variant="secondary"
                    className="ms-4"
                    onClick={() => history.goBack()}>
                    一覧に戻る
                  </Button>
                </>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isKubunBunruiConfirmModalShow}
        hideHandler={setIsKubunBunruiConfirmModalShow}
        submitHandler={kubunBunruiSubmit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isKubunConfirmModalShow}
        hideHandler={setIsKubunConfirmModalShow}
        submitHandler={kubunSubmit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
    </>
  )
}

export default MasterKubunRegister
